import { includes } from 'lodash';

import messageTypesMap from './messageTypesMap';

export default [
  {
    value: -1,
    label: 'Все сообщения',
    filterFn: () => true,
  },
  {
    value: 1,
    label: 'Обращения и жалобы',
    filterFn: (message) => message.notificationType === messageTypesMap.requests,
  },
  {
    value: 2,
    label: '3-НДФЛ',
    filterFn: (message) => message.notificationType === messageTypesMap.ndfl3,
  },
  {
    value: 3,
    label: 'Налоговые уведомления',
    filterFn: (message) => message.notificationType === messageTypesMap.taxMessage,
  },
  {
    value: 4,
    label: 'Требования об оплате',
    filterFn: (message) => message.notificationType === messageTypesMap.payment,
  },
  // todo: emikheev - return with insurance payments
  // {
  //   value: 5,
  //   label: "Уплата страховых взносов",
  //   filterFn: (message) => message.notificationType === messageTypesMap.insurancePayment
  // },
  {
    value: 6,
    label: 'Информационные сообщения',
    filterFn: (message) =>
      includes([messageTypesMap.info, messageTypesMap.infoForAnswer], message.notificationType),
    messageType: messageTypesMap.info,
  },
  {
    value: 10,
    label: 'Административное производство',
    filterFn: (message) => message.notificationType === messageTypesMap.administrativeProceeding,
  },
];
